import { devise } from "../../util/env";
import { NumericFormat } from "react-number-format";
export default function NumericFormatEnv({ Number }) {
  // integerValue = Math.floor(Number);
  return (
    <NumericFormat
      value={Number}
      displayType={"text"}
      thousandSeparator={" "}
      suffix={` ${devise}`}
    />
  );
}
